import { notify } from 'utils/reduxUtils';

export const types = {
  CHANGE_PASSWORD_ERROR: 'settings/userProfile/CHANGE_PASSWORD_ERROR',
  CHANGE_PASSWORD_INIT: 'settings/userProfile/CHANGE_PASSWORD_INIT',
  CHANGE_PASSWORD_REQUEST: 'settings/userProfile/CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS: 'settings/userProfile/CHANGE_PASSWORD_SUCCESS',
};

export const changePassword = {
  error: notify(
    (error) => ({
      type: types.CHANGE_PASSWORD_ERROR,
      payload: error,
    }),
    "Can't update password.",
  ),
  init: () => ({
    type: types.CHANGE_PASSWORD_INIT,
  }),
  request: ({ currentPassword, newPassword, newPasswordConf }) => ({
    type: types.CHANGE_PASSWORD_REQUEST,
    payload: { currentPassword, newPassword, newPasswordConf },
  }),
  success: notify(
    () => ({
      type: types.CHANGE_PASSWORD_SUCCESS,
    }),
    'New password saved.',
  ),
};
